import { Baby, ChevronLeft, GraduationCap, Heart, Gift, Moon } from "lucide-react";
import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";

const iconMap = {
  heart: Heart,
  baby: Baby,
  cap: GraduationCap,
  moon: Moon,
  gift: Gift,
} as const;

export function Occasions({ onSelect }: { onSelect: (occasion: string) => void }) {
  const reveal = useReveal<HTMLDivElement>();

  return (
    <section id="occasions" className="bg-l-accent-soft/40 py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
            {site.occasions.title}
          </h2>
          <p className="mt-4 text-base text-l-muted-foreground sm:text-lg">{site.occasions.sub}</p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {site.occasions.items.map((item) => {
            const Icon = iconMap[item.icon as keyof typeof iconMap] ?? Gift;
            return (
              <article
                key={item.value}
                className="flex flex-col rounded-3xl border border-l-border bg-l-card p-7 text-start shadow-l-soft transition-shadow hover:shadow-l-lift"
              >
                <span className="grid size-12 place-items-center rounded-2xl bg-l-accent-soft">
                  <Icon className="size-6 text-l-accent-strong" aria-hidden="true" />
                </span>
                <h3 className="mt-5 text-lg font-bold text-l-primary">{item.title}</h3>
                <p className="mt-2 grow text-sm leading-7 text-l-muted-foreground sm:text-base">
                  {item.text}
                </p>
                <button
                  type="button"
                  onClick={() => onSelect(item.value)}
                  className="mt-5 inline-flex min-h-12 items-center gap-1 self-start rounded-full text-sm font-medium text-l-accent-strong-foreground underline-offset-4 transition-colors hover:text-l-primary"
                >
                  {site.occasions.linkLabel}
                  <ChevronLeft className="size-4" aria-hidden="true" />
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
